var app_projections_table = $('#app-projections-table');

if (app_projections_table.length) {
    var data_table_order=[0, "asc"];
    function initializeProjectionsTable() {
        console.log('$$$$$$$$$$$$$$$$$');
        console.log(user_entries);
        console.log(data_table_order);
        window.app_projections_table
            .DataTable({
                ajax: {
                    url: '/projections/list',
                    dataSrc: 'data'
                    },
                columns: [
                    {data: 'name'},//0
                    {
                        data: 'daypart_id',
                        render: function(data, type, row) {
                            if (Array.isArray(data)) {
                                var names = data.map(function(daypart) {
                                    return daypart.name;
                                });
                                return names.join(' / ');
                            } else {
                                return data;
                            }
                        }
                    },//1
                    {
                        data: 'market_id',
                        render: function(data, type, row) {
                            if (Array.isArray(data)) {
                                var names = data.map(function(market) {
                                    return market.name;
                                });
                                return names.join(' / ');
                            } else {
                                return data;
                            }
                        }

                    },//2
                    {
                        data: 'vendor_id',
                        render: function(data, type, row) {
                            if (Array.isArray(data)) {
                                var names = data.map(function(market) {
                                    return market.name;
                                });
                                return names.join(' / ');
                            } else {
                                return data;
                            }
                        }

                    },//3
                    {data: 'telecast_type'},//4
                    {data: 'quarter'},//5
                    {data: 'id'}//6
                ],
                pageLength: user_entries,
                order: data_table_order,
                destroy: true,
                "columnDefs": [{
                    "targets": 6,
                    "orderable": false,
                    "createdCell": function (td, cellData, rowData, row, col) {
                        var html = '';
                        if (rowData.agency_id !== 0) {

                            var html = '<div class="btn-group">\n' +
                                '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                                '                <i class="fa fa-ellipsis-v"></i>\n' +
                                '                <span class="sr-only">Toggle Dropdown</span>\n' +
                                '            </button>\n' +
                                '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                                '                <li class="ms-hover">' + '<a href="/projections/' + cellData + '/edit" >' + '<i class="fa fa-pencil"></i> Edit' + '</a>' + '</li>\n' +
                                '                <li class="ms-hover">' + '<a href="javascript:void(0)" onclick="deleteProjection(\'' + cellData + '\')" >' + '<i class="fa fa-trash-o"></i> Delete' + '</a>' + '</li>\n' +
                                '                <li role="separator" class="divider ms-hover"></li>\n' +
                                '                <li class="ms-hover"><a href="/projections/' + cellData + '/report"><i class="fa fa-file"></i> Report</a></li>\n'
                            '            </ul>\n' +
                            '        </div>';



                            // var html = '<div class="row text-center"><div class="btn-group" role="group">' +
                            //     '<a href="/projections/' +
                            //     cellData +
                            //     '/edit" role="button" class="btn btn-success btn-sm">' +
                            //     '<i class="fa fa-pencil"></i> Edit ' +
                            //     '</a>';
                            //
                            // if(table_editable){
                            //     html += '<a href="javascript:void(0)" onclick="deleteProjection(\'' + cellData + '\')" role="button" class="btn btn-danger btn-sm">' +
                            //         '<i class="fa fa-trash-o"></i> Delete ' +
                            //         '</a>';
                            // }
                            // // html += '<a href="/projections/' + cellData + '/report" role="button" class="btn btn-info btn-sm">' +
                            // //     '<i class="fa fa-file"></i> Report ' +
                            // //     '</a></div></div>';
                            // html += '<a href="/projections/' + cellData + '/report" /* id="view_report2" */ role="button" class="btn btn-info btn-sm">' +
                            //     '<i class="fa fa-file"></i> Report ' +
                            //     '</a></div></div>';
                        }
                        $(td).html(html);
                    }
                }]
            });
    }

    $('#app-projections-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries= len;
    });
    $('#app-projections-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order=[len[0].col, ""+len[0].dir+""];
    } );


    function deleteProjection(urlVar) {
        $('#deleteProjectionConfirmed').attr('data-url', urlVar);
        $('#deleteProjectionWarningModal').modal('show');
    }
    function deleteProjectionConfirmed() {
        var urlVar = $('#deleteProjectionConfirmed').attr('data-url');
        show_loader();
        $.ajax({
            url: '/projections/' + urlVar + '/destroy',
            success: function (response) {
                global_notification('success', 'Projection deleted.')
                initializeProjectionsTable();
                $('#deleteProjectionWarningModal').modal('hide');
                hide_loader();
            },
            error: function (xhr) {
                if (xhr.status === 422) {
                    global_notification('warning', xhr.responseJSON.message);
                } else {
                    ajax_error();
                    debug(xhr.responseText);
                }
                hide_loader();
            }
        });
    }

    initializeProjectionsTable();
}
